<div class='content flex-column justify-center align-center'>
  <div class='profile-form flex-column'>
    <h3 class='section-label'>{{ 'complete-profile.jobTitleLabel' | translate }}</h3>
    <div class='toggle-grid two-col'>
      @for (title of jobTitleOptions; track title.key) {
        <button mat-button
                class='toggle-btn'
                data-testid='job-title-btn-{{title.key}}'
                [class.secondary-action]='!isJobTitleSelected(title.key)'
                [class.primary-action]='isJobTitleSelected(title.key)'
                (click)='toggleJobTitle(title.key)'>
          {{ title.label | translate }}
          @if (isJobTitleSelected(title.key)) {
            <mat-icon class='check-icon lt-md:hide'
                      svgIcon='check_circle'></mat-icon>
          }
        </button>
      }
    </div>
  </div>
</div>
